import { merge } from "lodash";
import { prefix } from "../helpers";

const profileNamespace = "profile";
const applicationPath = "application";

const nameSpace = merge({}, {
  get: {
    get: (id) => [`${prefix}/${profileNamespace}/${applicationPath}/${id}`],
    /** GET /profile/application - list applications. Pass { isApplicationMenu: true } to filter only menu applications */
    getAll: (opts = {}) => {
      const qs = opts && opts.isApplicationMenu === true ? "?isApplicationMenu=true" : "";
      return [`${prefix}/${profileNamespace}/${applicationPath}${qs}`];
    },
  },
});

export default nameSpace;
